import { Button, Modal, Notes, Paragraph } from 'canoe';
import React from 'react';

import { refresh } from 'commons/window';

export const FatalErrorModal = () => (
  <Modal severity="Danger">
    <Modal.Header title="An error has occurred while saving the Content" />
    <Modal.Body>
      <Paragraph size="long">
        Unfortunately, something went wrong while trying to save the very latest version of your
        Content.
      </Paragraph>
      <Notes>Reload the Editor to start creating content again.</Notes>
      <Button appearance="outline" variant="primary" onClick={refresh}>
        Reload Editor
      </Button>
    </Modal.Body>
  </Modal>
);

export default FatalErrorModal;
